module.exports = __webpack_public_path__ + "assets/img/gargoyle-hit.4959f087.png";